import { withTranslation } from 'react-i18next';

import DataTable from '../../../../components/Datatable';
import { getSortKeys, setAdditionalStyles } from '../../../../helpers/table';
import { definitionColumns, definitionRows } from '../keys';

/**
 * Block 01 — the topics the rest of the page is an answer to.
 *
 * It comes first because nothing below means anything without it. A topic here is a manual query
 * rule and nothing else — no semantic grouping, no clustering, no classification by Google or by
 * this app — so each one is stated with its policy, its case rule and the filters it was sent as
 * before any number is.
 *
 * It shows the *applied* topics, not the ones in the editor, so the page never attributes figures
 * to a definition that did not produce them.
 */
function TopicRules({ t, scope }) {
    const columns = definitionColumns(t);
    const rows = definitionRows(t, scope);

    return (
        <div className="card table-main rounded-main overflow-hidden gsc-tool-block">
            <div className="card-header d-flex justify-content-between">
                <div>
                    <p className="card-title">01 · {t('tools.topic_clusters.definition.title')}</p>
                    <p className="gsc-tool-sub">
                        {t('tools.topic_clusters.definition.description', {
                            topics: scope.topics.length,
                        })}
                    </p>
                </div>
            </div>

            <div className="card-body">
                <DataTable
                    nodes={rows}
                    COLUMNS={columns}
                    sortFns={getSortKeys(columns)}
                    additionalStyles={setAdditionalStyles(columns)}
                    onlyTable
                    notUseDefaultStyle
                    customContainerStyles="gsc-tool-rules-table"
                />

                <p className="gsc-tool-table-note">
                    {t('tools.topic_clusters.definition.manual_note')}
                </p>
                <p className="gsc-tool-table-note">
                    {t('tools.topic_clusters.definition.hidden_note')}
                </p>
                <p className="gsc-tool-table-note">
                    {t('tools.topic_clusters.definition.session_note')}
                </p>
            </div>
        </div>
    );
}

export default withTranslation()(TopicRules);
